import { LordIcon } from '@/shared/components/ui/lord-icon';
import { useStoreSlug } from '@/shared/hooks/use-store-slug';

import { useProfileNudge } from '../hooks/use-profile-nudge';

interface ProfileTabItemProps {
  icon: string;
  title: string;
  onClick: () => void;
}

/** Aba Perfil com ponto quando falta e-mail/CPF no perfil (PRAT-161). */
export function ProfileTabItem({ icon, title, onClick }: ProfileTabItemProps) {
  const { slug } = useStoreSlug();
  const { showDot } = useProfileNudge(slug);

  return (
    <button
      className="flex flex-col items-center justify-center space-y-2.5 h-16 py-2"
      onClick={onClick}
      aria-label={showDot ? `${title} (complete seu perfil)` : undefined}
    >
      <div className="relative">
        <LordIcon src={icon} trigger="click" size={26} />
        {showDot && (
          <div
            data-testid="profile-tab-dot"
            className="absolute top-0 right-0 w-2.5 h-2.5 bg-primary rounded-full"
          />
        )}
      </div>
      <span className="text-xs text-night">{title}</span>
    </button>
  );
}
